<div id="viewCompiledLicenseModal" class="modal" style="display:none" appDraggable dragTarget="#viewCompiledLicenseModal" dragHandle="#viewCompiledLicenseModalHeader"
  role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <!-- Dialog Header -->
      <div class="modal-header" id="viewCompiledLicenseModalHeader">
        <button type="button" class="close" data-dismiss="modal" (click)="hideDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
        <h4 class="modal-title">
          <i class="fa fa-pencil"></i> View Compiled License Details</h4>
      </div>

      <!-- Dialog Body -->
      <div class="modal-body">
        <div class="form-horizontal" *ngIf="mLicenseInfo != null">

          <!-- License Types -->
          <div class="form-group">
            <label class="control-label col-sm-4">License Types: </label>
            <div class="col-md-8">
              <table class="table table-bordered">
                <tbody>
                  <tr *ngFor="let type of mLicenseInfo?.license_types">
                    {{ type }}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Licensed Modules -->
          <div class="form-group">
            <label class="control-label col-sm-4">Licensed Modules: </label>
            <div class="col-md-8">
              <table class="table table-bordered">
                <tbody>
                  <tr *ngFor="let module of mLicenseInfo?.licensed_modules">
                    {{ module }}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Entity Type Limits -->
          <div class="form-group">
            <label class="control-label col-sm-4">Entity Type Limits: </label>
            <div class="col-md-8">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Entity Type</th>
                    <th>Limit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let limit of getEntityTypeLimits()">
                    <td>{{ limit.mEntityType }}</td>
                    <td>{{ limit.mLimit }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      <!-- Dialog Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-dismiss="modal">
          <i class="fa fa-ban" aria-hidden="true"></i> CLOSE</button>
      </div>
    </div>
  </div>
</div>
